import request from '@/utils/request'
import setting from '@/settings'
import qs from 'qs'
const apiUrl = setting.apiUrl

/**
 * 获取业务列表
 * @param data
 */
export const getBusinessList = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/business/getBusinessList`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取业务详情
 * @param data
 */
export const businessDetail = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/business/detail`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
* 获取院校列表
* @param data
*/
export const getSchoolList = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/school/getSchoolList`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取院校详情
 * @param data
 */
export const schoolDetail = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/school/detail`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取年级列表
 * @param data
 */
export const gradeSearch = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/grade/gradeSearch`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取年级详情
 * @param data
 */
export const gradeDetail = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/grade/detail`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取专业列表
 * @param data
 */
export const subjectSearch = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/subject/search`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取专业详情
 * @param data
 */
export const subjectDetail = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/subject/detail`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取学习类型列表
 * @param data
 */
export const studySearch = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/study/search`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取学习类型详情
 * @param data
 */
export const studyDetail = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/study/detail`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取业务院校树形
 * @param data
 */
export const leftBusinessSchoolTreeSearch = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/business/school/leftBusinessSchoolTreeSearch`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取业务院校列表
 * @param data
 */
export const businessSchoolSearch = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/business/school/businessSchoolSearch`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取院校年级树形
 * @param data
 */
export const leftSchoolGradeTreeSearch = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/school/grade/leftSchoolGradeTreeSearch`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取院校年级列表
 * @param data
 */
export const schoolGradeSearch = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/school/grade/schoolGradeSearch`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取院校专业树形
 * @param data
 */
export const leftSchoolTreeSearch = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/schoolSubject/leftSchoolTreeSearch`,
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取院校专业列表
 * @param data
 */
export const getSubjectBySchoolId = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/schoolSubject/getSubjectBySchoolId`,
    method: 'post',
    data: qs.stringify(data)
  })
